module.exports = __webpack_public_path__ + "static/media/presentation_phone1.b2ceb178.png";